/** @jsx jsx */
import { ExerciseIcon } from '@datacamp/waffles-icons';
import { jsx } from '@emotion/react';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { SidePanel } from '../SidePanel';
import DynamicTranscriptSlide from './DynamicTranscriptSlide';
import { jsx as ___EmotionJSX } from "@emotion/react";
const DynamicTranscript = _ref => {
  let {
    activeSlideIndex,
    duration,
    onClose,
    setSelectedProgress,
    slides,
    visible
  } = _ref;
  const slideRefs = useRef([]);
  const {
    t
  } = useTranslation();
  const setSlideRef = index => element => {
    slideRefs.current[index] = element;
  };
  useEffect(() => {
    if (slideRefs.current[activeSlideIndex]) {
      var _slideRefs$current$ac;
      (_slideRefs$current$ac = slideRefs.current[activeSlideIndex]) === null || _slideRefs$current$ac === void 0 || _slideRefs$current$ac.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, [activeSlideIndex]);
  return jsx(SidePanel, {
    className: "side-panel-container-dynamic-transcript",
    "data-testid": "dynamic-transcript",
    icon: jsx(ExerciseIcon, {
      size: "medium"
    }),
    onClose: onClose,
    title: t('Transcript.title'),
    visible: visible
  }, slides.map((slide, index) => {
    var _slides;
    return jsx(DynamicTranscriptSlide, {
      active: slide.number === activeSlideIndex + 1,
      duration: duration,
      key: slide.number,
      nextSlideStartsAt: (_slides = slides[index + 1]) === null || _slides === void 0 ? void 0 : _slides.startsAtTimestamp,
      ref: setSlideRef(index),
      setSelectedProgress: setSelectedProgress,
      slide: slide
    });
  }));
};
export default DynamicTranscript;